import {
  RENTAL_PURCHASES,
  TVOD_PURCHASE_PLAN_URL
} from 'src/utils/constants/ApiConstants';
import {
  HTTP_HEADER_KEYS,
  HTTP_METHODS,
  HTTP_URL_PARAMS
} from 'src/utils/constants/HttpMethodsConstants';
import { updateTVODRentals } from 'src/utils/rentalHelper';
import { buildUrlWithQueryParams } from 'src/utils/UrlGenerator';

import SimpleStore from '../../store/SimpleStore';
import { httpService } from '../fetch/HttpService';

export const fetchRentals = async () => {
  let rentalPurchases = [];
  const headers = [HTTP_HEADER_KEYS.AUTHORIZATION];
  try {
    rentalPurchases = await httpService.fetchApiData({
      url: RENTAL_PURCHASES,
      type: HTTP_METHODS.GET,
      headers
    });
    return updateTVODRentals(rentalPurchases);
  } catch (error) {
    rentalPurchases = [];
  }
};

export const fetchTvodPlans = async () => {
  const translation = SimpleStore.get(HTTP_URL_PARAMS.DISPLAY_LANGUAGE);
  const country = SimpleStore.get(HTTP_URL_PARAMS.COUNTRY_CODE);
  const url = buildUrlWithQueryParams(`${TVOD_PURCHASE_PLAN_URL}`, {
    translation,
    country,
    system: 'Z5',
    additionalDetails: 1,
    platform_name: 'web_app'
  });
  const allRendalPlans = await httpService.fetchApiData({
    url,
    type: HTTP_METHODS.GET
  });
  return allRendalPlans;
};
